var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UCard',{staticClass:"lesson-words-list"},[_c('vue-scroll',{ref:"scroll"},[_c('div',{staticClass:"lesson-words-list__inner"},_vm._l((_vm.words),function(item){return _c('NewWordsListItem',{key:item.id,staticClass:"lesson-words-list__words-list-item",attrs:{"word":item,"display-words-controls":_vm.displayWordsControls}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }